<template>
    <ul class="d-flex align-items-start justify-content-start position-relative w-100 p-0 m-0">
        <li class="d-flex w-100" :style="{ 'background-image': 'url('+banner+')'}" v-for="banner in this.$root.banners[this.$root.store_uid]"></li>
    </ul>
</template>

<script>

export default {
    name: "HeaderBanners",

    methods: {
        rotateBanners()
        {
            this.start_pub_slider();
        },
        start_pub_slider()
        {
            this.pub_count = document.querySelectorAll('#pub ul > li').length - 1;
            //this.pub_interval = setInterval(this.next_pub_slide,this.pub_time_slide);

        },
        next_pub_slide()
        {
            document.querySelector('#pub ul').style.left = '-100%';
        },
    },

    data(){
        return{
            pub_count: 0,
            pub_interval: false,
            pub_time_slide: 6000
        }
    },

    mounted: function mounted() {
        this.rotateBanners();
    },

}
</script>

<style scoped>

</style>
